/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид с новостями в каталоге. Автоматически вставляет новости после N товаров.
   * @param {app.CategoryItemsView} itemsView Вид каталога с товарами.
   */
  app.CategoryNewsItemsView = app.View.extend({
    additionalOptions: ['itemsView'],
    // Кол-во товаров после которых рендерить новость.
    NEWS_PER_ITEMS: 10,
    // Общее кол-во обработанных товаров. Требуется для бесконечного скролла.
    lastItemIndex: 0,
    shouldRemoveViewsOnSync: true,

    /** @inheritDoc */
    run: function () {
      this.collection = new app.NewsSearch();
      this.items = this.itemsView.model;
      this.itemViews = this.itemsView.childViews.itemViews;
      this.childViews.newsViews = [];
      // При самом первом срабатывании триггерятся оба события.
      this.listenTo(this.itemsView, 'itemsPerRowCalculated rendered', _.debounce(this.includeNews.bind(this), 400));
      this.listenTo(
        this.itemsView.chosenFilters,
        'reset',
        _.debounce(this.collection.setCategoryIdAndFetch.bind(this.collection, this.itemsView.chosenFilters), 400)
      );
      this.listenTo(this.items, 'query-updated', function (query) {
        this.collection.setQuery(query);
        this.removeNewsViews();
      });
      this.listenTo(this.collection, 'sync', function () {
        if (this.shouldRemoveViewsOnSync) {
          this.removeNewsViews();
        }
      });
    },

    /**
     * Очистка дочерних вью новостей.
     */
    removeNewsViews: function () {
      this.childViews.newsViews.forEach(function (view) {
        view.remove();
      });
      this.childViews.newsViews = [];
    },

    /**
     * Возвращает признак бесконечной прокрутки.
     * @return {boolean} Признак бесконечной прокрутки.
     */
    getIsInfinite: function () {
      return this.items.mode === 'infinite';
    },

    /**
     * Рассчитывает подходящую позицию для вставки новости относительно:
     * - текущего положения
     * - подходит ли через N товаров
     * - не находится на первых или последних двух рядах каталога
     * @param {Number} index Положение товара в каталоге.
     * @returns {number|undefined} Подходящая позиция для вставки новости.
     */
    calculatePosition: function (index) {
      var searchResultIndex = (this.items.state.currentPage - 1) * this.items.state.pageSize + (index),
        isPerItems = (searchResultIndex % this.NEWS_PER_ITEMS) === 0,
        row = Math.ceil(index / this.itemsView.itemsPerRow),
        pageRows = Math.ceil(this.itemViews.length / this.itemsView.itemsPerRow),
        firstItemInRowIndex = (row * this.itemsView.itemsPerRow);
      if (row > 1 && row < pageRows - 1 && isPerItems) {
        return firstItemInRowIndex;
      }
    },

    /**
     * Внедрение новостей.
     */
    includeNews: function () {
      var currentPageNews = this.childViews.newsViews.filter(function (view) {
        // В бесконечном скролле возвращаем копию
        return this.getIsInfinite() || (view.page === this.items.state.currentPage);
      }.bind(this));
      this.renderNews(currentPageNews);
    },

    /**
     * Отображает новости.
     * @param {Array} [newsViews] Массив новостей текущей страницы.
     */
    renderNews: function (newsViews) {
      var lastNewsIndex = 0;
      if (newsViews.length) {
        newsViews.forEach(function (view) {
          view.$el.remove();
        });
      }
      var indexesAwaitedNewsViews = [];
      this.itemViews.forEach(function (itemView, index) {
        var itemIndex = this.calculatePosition(index);
        if (itemIndex) {
          var result,
            hasNewsOnPage = newsViews.length && newsViews.length > lastNewsIndex;
          if (hasNewsOnPage) {
            // Перерисовываем имеющиеся виды
            result = newsViews[lastNewsIndex++];
            if (result) {
              this.itemViews[itemIndex].$el.before(result.render());
            }
          } else {
            indexesAwaitedNewsViews.push(itemIndex);
          }
        }
      }.bind(this));
      indexesAwaitedNewsViews.length && this.renderAwaitedNews(indexesAwaitedNewsViews);
    },

    /**
     * Запрос новых моделей новостей.
     */
    requestMoreNews: function () {
      if (this.collection.hasMoreNews()) {
        this.shouldRemoveViewsOnSync = false;
        this.listenToOnce(this.collection, 'sync', function () {
          this.renderAwaitedNews(this.indexesAwaitedNewsViews);
        });
        this.collection.requestMoreNews();
      }
    },

    /**
     * Создание дочерней вью новостей и рендер в список после указанного индекса.
     * @param {number} itemIndex Индекс товара в списке, после которого должна появиться новость.
     */
    createNewsViews: function (itemIndex) {
      var newsModel = this.collection.getUnusedModel();
      if (newsModel) {
        var view = new app.CategoryNewsItemView({
          page: this.items.state.currentPage,
          model: newsModel,
        });
        this.childViews.newsViews.push(view);
        this.itemViews[itemIndex].$el.before(view.render());
      } else {
        this.indexesAwaitedNewsViews.push(itemIndex);
      }
    },

    /**
     * Рендер недостающих в списке новостей.
     * @param {Array} itemIndexes - Массив индексов товаров.
     */
    renderAwaitedNews: function (itemIndexes) {
      this.shouldRemoveViewsOnSync = true;
      this.indexesAwaitedNewsViews = [];
      itemIndexes.forEach(function (index) {
        this.createNewsViews(index);
      }.bind(this));
      // если есть места для новостей, и все новости использованы, запрашиваем новые
      this.indexesAwaitedNewsViews.length && this.requestMoreNews();
    }
  });
})();

}.call(window));